import React from 'react'
import { View, Image, useWindowDimensions, Linking, ImageBackground, Pressable } from 'react-native'
import { Text, Button } from '@ui-kitten/components'
import tailwind from 'tailwind-rn'
import { useNavigation } from '@react-navigation/native'
import { useMediaQuery } from 'react-responsive'

import Colors from '../constants/Colors'

const FooterInterno = () => {

  const isLargeScreen = useMediaQuery({minDeviceWidth: 440})
  const windowWidth = isLargeScreen ? 800 : useWindowDimensions().width
  const windowHeight = useWindowDimensions().height
  const navigation = useNavigation()

  const _goSebrae = () => {
    Linking.openURL('https://www.sebrae.com.br/sites/PortalSebrae/ufs/ba?codUf=5')
  }

  const _goSenac = () => {
    Linking.openURL('https://www.ba.senac.br')
  }

  const _goInstagram = () => {
    Linking.openURL('https://www.instagram.com/senacbahia')
  }

  const _goFacebook = () => {
    Linking.openURL('https://www.facebook.com/SenacBahia/')
  }

  const _goYoutube = () => {
    Linking.openURL('https://www.youtube.com/channel/UCybJWpVh2-GceJ0CnkyM9JA')
  }

    return (
      <View style={{top: isLargeScreen ? 470 : 120, width: windowWidth}}>
      <ImageBackground source={require('../assets/images/bg_footer.svg')} style={{width: windowWidth, height: isLargeScreen ? 660 : 300, bottom: 0, position: 'absolute', zIndex:10}} resizeMode="contain" >
        <View style={tailwind('mx-5 mt-10 flex-row self-center')}>
          <Image source={require('../assets/images/logos.svg')} style={{width: windowWidth-100, height: 50, tintColor: Colors.cinza}} resizeMode="contain" />
        </View>
        <View style={[tailwind('bg-black mx-5 mt-5'), { height: 1 }]} />
        <View style={tailwind('mx-5 flex-row self-center')}>
          <Pressable onPress={_goYoutube}><Image source={require('../assets/images/youtube_color.svg')} style={{width: windowWidth*0.09, height: windowHeight*0.09, marginRight: 30, tintColor: Colors.cinza}} resizeMode="contain" /></Pressable>
          <Pressable onPress={_goInstagram}><Image source={require('../assets/images/instagram_color.svg')} style={{width: windowWidth*0.07, height: windowHeight*0.07, marginRight: 30, marginTop: 8, tintColor: Colors.cinza}} resizeMode="contain" /></Pressable>
          <Pressable onPress={_goFacebook}><Image source={require('../assets/images/facebook_color.svg')} style={{width: windowWidth*0.030, height: windowHeight*0.030, marginTop: 25, tintColor: Colors.cinza}} resizeMode="contain" /></Pressable>
        </View>
        <View style={[tailwind('bg-black mx-5'), { height: 1 }]} />
        <Text style={tailwind('mx-5 mt-5 self-center text-xs')}>Copyright 2021 © Senac</Text>
      </ImageBackground>     
      </View>         

    )
  }

export default FooterInterno
